var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.75C1.86193 6.75 1.75 6.86193 1.75 7V20C1.75 20.1381 1.86193 20.25 2 20.25H16C16.1381 20.25 16.25 20.1381 16.25 20V7C16.25 6.86193 16.1381 6.75 16 6.75H2ZM0.25 7C0.25 6.0335 1.0335 5.25 2 5.25H16C16.9665 5.25 17.75 6.0335 17.75 7V20C17.75 20.9665 16.9665 21.75 16 21.75H2C1.0335 21.75 0.25 20.9665 0.25 20V7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.75C7.4812 1.75 6.25 2.98122 6.25 4.5V8C6.25 8.41421 5.91421 8.75 5.5 8.75C5.08579 8.75 4.75 8.41421 4.75 8V4.5C4.75 2.15279 6.65279 0.25 9 0.25C11.3472 0.25 13.25 2.15279 13.25 4.5V8C13.25 8.41421 12.9142 8.75 12.5 8.75C12.0858 8.75 11.75 8.41421 11.75 8V4.5C11.75 2.98122 10.5188 1.75 9 1.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.dc362f871493bac565a9be01eff877d9.svg";
export { ForwardRef as ReactComponent };